/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/library_delete" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdLibraryDeleteCacheKeys } from "./constants";
import type { PostEngagementAppGroupIdLibraryDeleteProps, EngagementAppGroupIdLibraryDeleteResult } from "./types";

export const postEngagementAppGroupIdLibraryDelete = reactQueryMutationAdapter(
  engagementAppGroupIdLibraryDeleteCacheKeys,
  ({
    appGroupId,
    imageIds,
  }: PostEngagementAppGroupIdLibraryDeleteProps): Promise<EngagementAppGroupIdLibraryDeleteResult> => {
    return fetch(`/engagement/${appGroupId}/library_delete`, "POST", { image_ids: imageIds });
  }
);
